/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserAccountApiLambdaModelsMembershipStatuses {
  Unknown = "unknown",
  Current = "current",
  Renewing = "renewing",
  Suspended = "suspended",
  Expired = "expired",
  Coolingoff = "coolingoff",
}

export enum UserAccountAPIDataTransferObjectsUserType {
  Performer = "Performer",
  Agent = "Agent",
  CastingDirector = "CastingDirector",
}

export enum UserAccountAPIDataOnlineApplicationsDbEntitiesEnumsPathway {
  Eligibility = "Eligibility",
  Training = "Training",
  Recommendation = "Recommendation",
}

export enum ProfileApiCommonModelsEnumsPlatform {
  Spotlight = "Spotlight",
  StagePool = "StagePool",
  FilmMakers = "FilmMakers",
}

export enum ProfileApiCommonModelsEnumsPerformerType {
  YoungPerformer = "YoungPerformer",
  Graduate = "Graduate",
  Performer = "Performer",
  Stagepool = "Stagepool",
}

export enum AuthCacheMemberGroupsModelsMemberSubType {
  YoungPerformer = "youngPerformer",
  Graduate = "graduate",
  SearchOnlyCastingDirector = "searchOnlyCastingDirector",
}

export enum AuthCacheMemberGroupsModelsMemberGroupNames {
  CastingDirector = "castingDirector",
  Performer = "performer",
  Agent = "agent",
}

export interface AuthCacheMemberGroupsModelsUserInformationModel {
  memberGroup?: AuthCacheMemberGroupsModelsMemberGroupNames;
  memberSubType?: AuthCacheMemberGroupsModelsMemberSubType;
  membershipStatus?: UserAccountApiLambdaModelsMembershipStatuses;
  performerNameTaken?: boolean;
  disableOnlineReactivate?: boolean;
  /** @format int32 */
  daysRemaining?: number | null;
  contractId?: string | null;
  managedByRecurly?: boolean;
  active?: boolean;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProfileApiCommonModelsApiEndpointsCreateProfileResponse {
  /** @format uuid */
  profileId?: string;
  viewPin?: string | null;
  problems?: string[] | null;
}

export interface UserAccountAPIApiModelsArtistProfileCreationData {
  /** @maxLength 24 */
  forenames?: string | null;
  /**
   * @minLength 1
   * @maxLength 30
   */
  surname: string;
  performerType: ProfileApiCommonModelsEnumsPerformerType;
  platform: ProfileApiCommonModelsEnumsPlatform;
  agentRefNumbers: number[];
  /** @minLength 1 */
  mainPhotoUrl: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  mainPhotoPhotographerName: string;
  /** @maxLength 512 */
  mainPhotoDescription?: string | null;
  /** @format int32 */
  playingAgeFrom: number;
  /** @format int32 */
  playingAgeTo: number;
}

export interface UserAccountAPIApiModelsUserAccountLogMessage {
  /** @format uuid */
  portalId?: string | null;
  /** @format date-time */
  date?: string;
  message?: string | null;
  accessToken?: string | null;
  userAgent?: string | null;
  level?: string | null;
  tabSessionId?: string | null;
}

export interface UserAccountAPIApiServicesContractsSettingsEmailVerificationRequest {
  emailAddress?: string | null;
  /** @format uuid */
  userGuid?: string;
  verificationUri?: string | null;
}

export interface UserAccountAPIApiServicesContractsSettingsSaveSecurityQuestionRequest {
  question?: string | null;
  answer?: string | null;
}

export interface UserAccountAPIApiServicesContractsSettingsUpdateEmailRequest {
  email?: string | null;
  /** @format uuid */
  userGuid?: string;
}

export interface UserAccountAPIApiServicesContractsSettingsUpdatePasswordRequest {
  password?: string | null;
  /** @format uuid */
  userGuid?: string;
}

export interface UserAccountAPIDataTransferObjectsAboutYouGraduateInputDto {
  /** @format int32 */
  id?: number;
  course?: string | null;
  /** @format date-time */
  courseStartDate?: string;
  /** @format date-time */
  courseEndDate?: string;
  /** @format int32 */
  playingAgeFrom?: number;
  /** @format int32 */
  playingAgeTo?: number;
  /** @format date-time */
  dateOfBirth?: string | null;
  deafOrDisabled?: boolean;
  dateOfBirthPublicationOption?: boolean;
  address?: UserAccountAPIDataTransferObjectsAddressDto;
}

export interface UserAccountAPIDataTransferObjectsAboutYouInputDto {
  appearedBefore?: string | null;
  appearedBeforeEmail?: string | null;
  appearedBeforeName?: string | null;
  /** @format int32 */
  appearingNowPublicationCode?: number | null;
  /** @format int32 */
  id?: number;
  phone1?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  dateOfBirthPublicationOption?: string | null;
  /** @format int32 */
  playingAgeFrom?: number;
  /** @format int32 */
  playingAgeTo?: number;
  /** @format int32 */
  findMeAs?: number;
  /** @format int32 */
  customOrNonBinaryGender?: number | null;
  showGenderOnProfile?: string | null;
  deafOrDisabled?: boolean;
  furtherInformation?: string | null;
  membershipOptions?: number[] | null;
  /** @format int32 */
  bookId?: number;
  agents?: number[] | null;
  address?: UserAccountAPIDataTransferObjectsAddressDto;
  /** @minLength 1 */
  mobileNumber: string;
}

export interface UserAccountAPIDataTransferObjectsAboutYouYPInputDto {
  /** @format int32 */
  id?: number;
  phone1?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  dateOfBirthPublicationOption?: string | null;
  /** @format int32 */
  playingAgeFrom?: number;
  /** @format int32 */
  playingAgeTo?: number;
  /** @format int32 */
  findMeAs?: number;
  /** @format int32 */
  customOrNonBinaryGender?: number | null;
  showGenderOnProfile?: string | null;
  deafOrDisabled?: boolean;
  furtherInformation?: string | null;
  membershipOptions?: number[] | null;
  /** @format int32 */
  bookId?: number;
  agents?: number[] | null;
}

export interface UserAccountAPIDataTransferObjectsAddressDto {
  street1?: string | null;
  street2?: string | null;
  city?: string | null;
  postal_Code?: string | null;
  country?: string | null;
  stateProvince?: string | null;
  phone?: string | null;
}

export interface UserAccountAPIDataTransferObjectsAgentsCreateAgentApplicationInputDto {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  agency: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /**
   * @format uri
   * @minLength 1
   */
  website: string;
  /** @minLength 1 */
  contactNumber: string;
  /** @minLength 1 */
  agentType: string;
}

export interface UserAccountAPIDataTransferObjectsCDAboutYouInputDto {
  /** @format int32 */
  experienceLookUpId?: number | null;
  creditUrls?: string[] | null;
  /** @format int32 */
  useSpotlightForLookUpId: number;
  useSpotlightForNotSureDetails?: string | null;
  cvS3ObjectKey?: string | null;
  castingForUnder18: boolean;
  castingForUnder18Aware?: boolean | null;
  address?: UserAccountAPIDataTransferObjectsAddressDto;
}

export interface UserAccountAPIDataTransferObjectsCreateCastingOnlineApplicationDto {
  appearedBefore?: string | null;
  appearedBeforeEmail?: string | null;
  appearedBeforeName?: string | null;
  /** @format int32 */
  appearingNowPublicationCode?: number | null;
  /** @minLength 1 */
  forename: string;
  /** @minLength 1 */
  surname: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @format int32 */
  occupationLookUpId: number;
  /** @minLength 1 */
  companyName: string;
  /** @minLength 1 */
  mobile: string;
  phone?: string | null;
  companyWebsite?: string | null;
  /** @format int32 */
  organisationLookUpId?: number | null;
  membershipNumber?: string | null;
  membershipName?: string | null;
  /** @format email */
  membershipEmail?: string | null;
  address?: UserAccountAPIDataTransferObjectsAddressDto;
}

export interface UserAccountAPIDataTransferObjectsCreateCreditsInputDto {
  /** @minLength 1 */
  productionName: string;
  /** @format int32 */
  productionType: number;
  /** @minLength 1 */
  roleName: string;
  /** @minLength 1 */
  company: string;
  /** @minLength 1 */
  director: string;
  /** @format date-time */
  dateFrom: string;
  /** @format date-time */
  dateTo: string;
  /** @minLength 1 */
  isEquity: string;
  s3ObjectKey?: string | null;
  contractUri?: string | null;
}

export interface UserAccountAPIDataTransferObjectsCreateGraduateApplication {
  /**
   * @minLength 1
   * @maxLength 24
   */
  forenames: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  surname: string;
  /**
   * @format email
   * @minLength 1
   * @maxLength 50
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 50
   */
  schoolPassword: string;
}

export interface UserAccountAPIDataTransferObjectsCreateOnlineApplicationDto {
  /** @minLength 1 */
  forenames: string;
  /** @minLength 1 */
  surname: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  bookCode?: string | null;
  genderInitial?: string | null;
  /** @format int32 */
  bookSection?: number;
  /** @maxLength 50 */
  referredBy?: string | null;
  /** @maxLength 100 */
  referralId?: string | null;
}

export interface UserAccountAPIDataTransferObjectsCreateRecommendationInputDto {
  /** @minLength 1 */
  fullName: string;
  /** @minLength 1 */
  refereeMembership: string;
  /** @minLength 1 */
  s3ObjectKey: string;
}

export interface UserAccountAPIDataTransferObjectsCreateTrainingInputDto {
  /** @minLength 1 */
  schoolName: string;
  /** @minLength 1 */
  courseName: string;
  /** @format date-time */
  dateFrom: string;
  /** @format date-time */
  dateTo: string;
  /** @format int32 */
  qualificationLevel: number;
  courseUri?: string | null;
  /** @minLength 1 */
  isFullTime: string;
  /** @minLength 1 */
  s3ObjectKey: string;
}

export interface UserAccountAPIDataTransferObjectsCreateYPOnlineApplicationDto {
  appearedBefore?: string | null;
  appearedBeforeEmail?: string | null;
  appearedBeforeName?: string | null;
  /** @format int32 */
  appearingNowPublicationCode?: number | null;
  /**
   * @minLength 1
   * @maxLength 24
   */
  forenames: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  surname: string;
  /**
   * @format email
   * @minLength 1
   * @maxLength 50
   */
  email: string;
  /** @format date-time */
  dateOfBirth: string;
  /**
   * @minLength 1
   * @maxLength 24
   */
  parentForenames: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  parentSurname: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  mobileNumber: string;
  address?: UserAccountAPIDataTransferObjectsAddressDto;
  bookCode?: string | null;
  genderInitial?: string | null;
  /** @format int32 */
  bookSection?: number;
  /** @maxLength 50 */
  referredBy?: string | null;
  /** @maxLength 100 */
  referralId?: string | null;
}

export interface UserAccountAPIDataTransferObjectsCreditInputDto {
  name?: string | null;
  /** @format int32 */
  typeId?: number;
  role?: string | null;
  company?: string | null;
  director?: string | null;
  /** @format date-time */
  date?: string | null;
}

export interface UserAccountAPIDataTransferObjectsForgotPasswordInputDto {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface UserAccountAPIDataTransferObjectsGeneratePresignedUrlInputDto {
  /** @minLength 1 */
  key: string;
  /** @format int32 */
  validForMinutes?: number | null;
  httpVerb?: string | null;
}

export interface UserAccountAPIDataTransferObjectsGraduateCreditsSkillsAndAgentInputDto {
  credits?: UserAccountAPIDataTransferObjectsCreditInputDto[] | null;
  skills?: UserAccountAPIDataTransferObjectsSkillInputDto[] | null;
  /** @format int32 */
  refNumber?: number;
}

export interface UserAccountAPIDataTransferObjectsGraduatesGraduateCharacteristicsInputDto {
  /** @format double */
  height?: number | null;
  /** @format int32 */
  appearance?: number | null;
  /** @format int32 */
  eyeColour?: number | null;
  /** @format int32 */
  hairColour?: number | null;
  /** @format int32 */
  hairLength?: number | null;
  /** @format int32 */
  facialHair?: number | null;
  hasTwinOnSpotlight?: boolean;
  voiceStyles?: number[] | null;
  /** @format int32 */
  beltNote?: number | null;
  /** @format double */
  lowerNote?: number | null;
  /** @format double */
  upperNote?: number | null;
}

export interface UserAccountAPIDataTransferObjectsGraduatesGraduateValidatePasswordInputDto {
  schoolPassword?: string | null;
}

export interface UserAccountAPIDataTransferObjectsGraduatesResponsesGraduateApplicationOutputDto {
  /** @format int32 */
  applicationId?: number;
  securityKey?: string | null;
  accountId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  school?: string | null;
  course?: string | null;
  /** @format date-time */
  courseStartDate?: string | null;
  /** @format date-time */
  courseEndDate?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  deafOrDisabled?: boolean;
  /** @format int32 */
  playingAgeFrom?: number | null;
  /** @format int32 */
  playingAgeTo?: number | null;
  isVisibleAge?: boolean;
  address?: UserAccountAPIDataTransferObjectsAddressDto;
  /** @format int32 */
  gender?: number | null;
  customOrNonBinaryGender?: UserAccountAPIDataTransferObjectsLookUpDto;
  genderInfo?: string | null;
  isVisibleGender?: boolean | null;
  locations?: string[] | null;
  /** @format double */
  height?: number | null;
  appearance?: UserAccountAPIDataTransferObjectsLookUpDto[] | null;
  eyeColor?: UserAccountAPIDataTransferObjectsLookUpDto;
  hairLength?: UserAccountAPIDataTransferObjectsLookUpDto;
  hairColor?: UserAccountAPIDataTransferObjectsLookUpDto;
  facialHair?: UserAccountAPIDataTransferObjectsLookUpDto;
  voiceStyles?: UserAccountAPIDataTransferObjectsLookUpDto[] | null;
  /** @format double */
  singingRangeUpperNote?: number | null;
  /** @format double */
  singingRangeLowerNote?: number | null;
  singingRangeBeltNotes?: UserAccountAPIDataTransferObjectsLookUpDto[] | null;
  twin?: boolean | null;
  /** @format int32 */
  agencyRefNumber?: number | null;
  agencyName?: string | null;
  photograph?: UserAccountAPIDataTransferObjectsPhotographOutputDto;
  marketingPreferences?: string[] | null;
}

export interface UserAccountAPIDataTransferObjectsGraduatesTransferCreateGraduateTransferInputDto {
  schoolPassword?: string | null;
  training?: string | null;
  /** @format int32 */
  trainingFromYear?: number;
  /** @format int32 */
  trainingToYear?: number;
  agents?: number[] | null;
}

export interface UserAccountAPIDataTransferObjectsLookUpDto {
  /** @format int32 */
  lookupCode?: number;
  description?: string | null;
  /** @format int32 */
  groupCode?: number;
  /** @format int32 */
  facetId?: number;
  /** @format int32 */
  orderKey?: number | null;
}

export interface UserAccountAPIDataTransferObjectsPathwayInputDto {
  pathway: UserAccountAPIDataOnlineApplicationsDbEntitiesEnumsPathway;
}

export interface UserAccountAPIDataTransferObjectsPhotographOutputDto {
  photoKey?: string | null;
  photographerName?: string | null;
  photoDescription?: string | null;
}

export interface UserAccountAPIDataTransferObjectsRecurlyAccountDetailsDto {
  accountId?: string | null;
}

export interface UserAccountAPIDataTransferObjectsRecurlyDetailsDto {
  planId?: string | null;
  planCurrency?: string | null;
  couponCode?: string | null;
  couponCodes?: string[] | null;
  addOns?: string[] | null;
  billingInfoId?: string | null;
}

export interface UserAccountAPIDataTransferObjectsRegisterDeviceDto {
  /** @minLength 1 */
  token: string;
  platform?: string | null;
}

export interface UserAccountAPIDataTransferObjectsResumeOnlineApplicationDto {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @minLength 1 */
  password: string;
  /** @format int32 */
  bookId?: number;
}

export interface UserAccountAPIDataTransferObjectsSkillInputDto {
  /** @format int32 */
  facetId?: number;
  /** @format int32 */
  levelId?: number | null;
}

export interface UserAccountAPIDataTransferObjectsUpdateGraduateDetailsDto {
  /** @format int32 */
  applicationId?: number;
  /** @format int32 */
  publishedGender?: number;
  genderFurtherInformation?: string | null;
  showGenderOnProfile?: boolean;
  /** @format int32 */
  customOrNonBinaryGender?: number | null;
  locationIds?: string[] | null;
  /** @format int32 */
  agencyRefNumber?: number | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title UserAccount API
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  account = {
    /**
     * No description
     *
     * @tags Account
     * @name AccountGet
     * @request GET:/Account
     * @secure
     */
    accountGet: <
      TResponse = AuthCacheMemberGroupsModelsUserInformationModel[],
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Account`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountCreateArtistProfileArtistProfileCreationData
     * @request POST:/Account/CreateArtistProfile
     * @secure
     */
    accountCreateArtistProfileArtistProfileCreationData: <
      TResponse = ProfileApiCommonModelsApiEndpointsCreateProfileResponse,
      TError = any,
    >(
      data: UserAccountAPIApiModelsArtistProfileCreationData,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Account/CreateArtistProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountCreateFilmMakerArtistProfileArtistProfileCreationData
     * @request POST:/Account/create/filmmakers
     */
    accountCreateFilmMakerArtistProfileArtistProfileCreationData: <
      TResponse = ProfileApiCommonModelsApiEndpointsCreateProfileResponse,
      TError = any,
    >(
      data: UserAccountAPIApiModelsArtistProfileCreationData,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Account/create/filmmakers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountCreateArtistProfileGuidArtistProfileCreationData
     * @request POST:/Account/CreateArtistProfile/{portalGuid}
     * @secure
     */
    accountCreateArtistProfileGuidArtistProfileCreationData: <
      TResponse = ProfileApiCommonModelsApiEndpointsCreateProfileResponse,
      TError = any,
    >(
      portalGuid: string,
      data: UserAccountAPIApiModelsArtistProfileCreationData,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Account/CreateArtistProfile/${portalGuid}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountSuspendGuid
     * @request POST:/Account/{artistPortalGuid}/suspend
     * @secure
     */
    accountSuspendGuid: <TResponse = boolean, TError = any>(
      artistPortalGuid: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Account/${artistPortalGuid}/suspend`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name AccountActivateGuid
     * @request POST:/Account/{artistPortalGuid}/activate
     * @secure
     */
    accountActivateGuid: <TResponse = boolean, TError = any>(
      artistPortalGuid: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Account/${artistPortalGuid}/activate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  activities = {
    /**
     * No description
     *
     * @tags Activities
     * @name ActivitiesPostUserAccountLogMessage
     * @request POST:/Activities
     */
    activitiesPostUserAccountLogMessage: <TResponse = unknown, TError = any>(
      data: UserAccountAPIApiModelsUserAccountLogMessage,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Activities`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  application = {
    /**
     * No description
     *
     * @tags Application
     * @name ApplicationGetInt32Boolean
     * @request GET:/Application
     */
    applicationGetInt32Boolean: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
        /** @default true */
        includeAddress?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostAboutYouInt32AboutYouInputDto
     * @request POST:/Application/aboutyou
     */
    applicationPostAboutYouInt32AboutYouInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsAboutYouInputDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/aboutyou`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationMarketingPreferencesInt32List1
     * @request POST:/Application/MarketingPreferences
     */
    applicationMarketingPreferencesInt32List1: <
      TResponse = unknown,
      TError = any,
    >(
      data: string[],
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/MarketingPreferences`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationGetMarketingPreferences
     * @request GET:/Application/marketingpreferences
     */
    applicationGetMarketingPreferences: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/marketingpreferences`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationCreateCreateOnlineApplicationDto
     * @request POST:/Application/Create
     */
    applicationCreateCreateOnlineApplicationDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails | unknown,
    >(
      data: UserAccountAPIDataTransferObjectsCreateOnlineApplicationDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/Create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationCreateForYoungPerformerCreateYpOnlineApplicationDtoGuid
     * @request POST:/Application/yp/create
     */
    applicationCreateForYoungPerformerCreateYpOnlineApplicationDtoGuid: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails | unknown,
    >(
      data: UserAccountAPIDataTransferObjectsCreateYPOnlineApplicationDto,
      query?: {
        /** @format uuid */
        agentCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/yp/create`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostYoungPerformerAboutYouInt32AboutYouYpInputDto
     * @request POST:/Application/yp/aboutyou
     */
    applicationPostYoungPerformerAboutYouInt32AboutYouYpInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsAboutYouYPInputDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/yp/aboutyou`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationValidateYpAgentGuid
     * @request GET:/Application/ValidateYPAgent
     */
    applicationValidateYpAgentGuid: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      query?: {
        /** @format uuid */
        agentCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/ValidateYPAgent`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostGeneratePreSignedUrlInt32GeneratePresignedUrlInputDtoNullable1
     * @request POST:/Application/generatepresignedurl
     */
    applicationPostGeneratePreSignedUrlInt32GeneratePresignedUrlInputDtoNullable1:
      <TResponse = unknown, TError = MicrosoftAspNetCoreMvcProblemDetails>(
        data: UserAccountAPIDataTransferObjectsGeneratePresignedUrlInputDto,
        query?: {
          /** @format int32 */
          onlineApplicationId?: number;
          userType?: UserAccountAPIDataTransferObjectsUserType;
        },
        params: RequestParams = {},
      ) =>
        this.request<TResponse, TError>({
          path: `/Application/generatepresignedurl`,
          method: "POST",
          query: query,
          body: data,
          type: ContentType.Json,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationResumeResumeOnlineApplicationDto
     * @request POST:/Application/Resume
     */
    applicationResumeResumeOnlineApplicationDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails | unknown,
    >(
      data: UserAccountAPIDataTransferObjectsResumeOnlineApplicationDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/Resume`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationGetQualificationLevels
     * @request GET:/Application/qualificationlevels
     */
    applicationGetQualificationLevels: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/qualificationlevels`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationGetProductionTypes
     * @request GET:/Application/productiontypes
     */
    applicationGetProductionTypes: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/productiontypes`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostCreateCreditsInt32List1
     * @request POST:/Application/credits
     */
    applicationPostCreateCreditsInt32List1: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsCreateCreditsInputDto[],
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/credits`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostCreateTrainingInt32List1
     * @request POST:/Application/training
     */
    applicationPostCreateTrainingInt32List1: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsCreateTrainingInputDto[],
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/training`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostCreateRecommendationsInt32List1
     * @request POST:/Application/recommendations
     */
    applicationPostCreateRecommendationsInt32List1: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsCreateRecommendationInputDto[],
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/recommendations`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostResetPathwayInt32PathwayInputDto
     * @request POST:/Application/pathway
     */
    applicationPostResetPathwayInt32PathwayInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsPathwayInputDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/pathway`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostForgotPasswordForgotPasswordInputDto
     * @request POST:/Application/forgotpassword
     */
    applicationPostForgotPasswordForgotPasswordInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsForgotPasswordInputDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/forgotpassword`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationGetPerformerTypes
     * @request GET:/Application/performertypes
     */
    applicationGetPerformerTypes: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/performertypes`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationPostCompletedInt32RecurlyDetailsDto
     * @request POST:/Application/completed
     */
    applicationPostCompletedInt32RecurlyDetailsDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsRecurlyDetailsDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/completed`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationUpdateOnlineApplicationAccountIdInt32RecurlyAccountDetailsDto
     * @request POST:/Application/account
     */
    applicationUpdateOnlineApplicationAccountIdInt32RecurlyAccountDetailsDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsRecurlyAccountDetailsDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/account`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationCreateAgentJoiningApplicationCreateAgentApplicationInputDto
     * @request POST:/Application/agent
     */
    applicationCreateAgentJoiningApplicationCreateAgentApplicationInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsAgentsCreateAgentApplicationInputDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Application/agent`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationCreateGraduateCreateGraduateApplication
     * @request POST:/application/graduate/create
     */
    graduateApplicationCreateGraduateCreateGraduateApplication: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsCreateGraduateApplication,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationPostGraduateAboutYouInt32AboutYouGraduateInputDto
     * @request POST:/application/graduate/aboutyou
     */
    graduateApplicationPostGraduateAboutYouInt32AboutYouGraduateInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsAboutYouGraduateInputDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/aboutyou`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationPostForgotPasswordForgotPasswordInputDto
     * @request POST:/application/graduate/forgotpassword
     */
    graduateApplicationPostForgotPasswordForgotPasswordInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsForgotPasswordInputDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/forgotpassword`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationResumeGraduateResumeOnlineApplicationDto
     * @request POST:/application/graduate/resume
     */
    graduateApplicationResumeGraduateResumeOnlineApplicationDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsResumeOnlineApplicationDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/resume`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationPostCharacteristicsInt32GraduateCharacteristicsInputDto
     * @request POST:/application/graduate/characteristics
     */
    graduateApplicationPostCharacteristicsInt32GraduateCharacteristicsInputDto:
      <TResponse = unknown, TError = MicrosoftAspNetCoreMvcProblemDetails>(
        data: UserAccountAPIDataTransferObjectsGraduatesGraduateCharacteristicsInputDto,
        query?: {
          /** @format int32 */
          onlineApplicationId?: number;
        },
        params: RequestParams = {},
      ) =>
        this.request<TResponse, TError>({
          path: `/application/graduate/characteristics`,
          method: "POST",
          query: query,
          body: data,
          type: ContentType.Json,
          ...params,
        }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationGetCharacteristicsLookups
     * @request GET:/application/graduate/characteristics/lookups
     */
    graduateApplicationGetCharacteristicsLookups: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/characteristics/lookups`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationGraduateDetailsInt32UpdateGraduateDetailsDto
     * @request POST:/application/graduate/details
     */
    graduateApplicationGraduateDetailsInt32UpdateGraduateDetailsDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsUpdateGraduateDetailsDto,
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/details`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationReviewInt32String
     * @request GET:/application/graduate/review
     */
    graduateApplicationReviewInt32String: <
      TResponse = UserAccountAPIDataTransferObjectsGraduatesResponsesGraduateApplicationOutputDto,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      query?: {
        /** @format int32 */
        onlineApplicationId?: number;
        securityKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/review`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateApplication
     * @name GraduateApplicationPostGraduateCreditsSkillsAndAgentInt32GraduateCreditsSkillsAndAgentInputDto
     * @request POST:/application/graduate/csa
     */
    graduateApplicationPostGraduateCreditsSkillsAndAgentInt32GraduateCreditsSkillsAndAgentInputDto:
      <TResponse = unknown, TError = MicrosoftAspNetCoreMvcProblemDetails>(
        data: UserAccountAPIDataTransferObjectsGraduateCreditsSkillsAndAgentInputDto,
        query?: {
          /** @format int32 */
          onlineApplicationId?: number;
        },
        params: RequestParams = {},
      ) =>
        this.request<TResponse, TError>({
          path: `/application/graduate/csa`,
          method: "POST",
          query: query,
          body: data,
          type: ContentType.Json,
          ...params,
        }),

    /**
     * No description
     *
     * @tags GraduateTransfer
     * @name GraduateTransferValidateSchoolPasswordGraduateValidatePasswordInputDto
     * @request POST:/application/graduate/transfer/validateschool
     */
    graduateTransferValidateSchoolPasswordGraduateValidatePasswordInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsGraduatesGraduateValidatePasswordInputDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/transfer/validateschool`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GraduateTransfer
     * @name GraduateTransferCreateGraduateTransferApplicationCreateGraduateTransferInputDto
     * @request POST:/application/graduate/transfer/create
     */
    graduateTransferCreateGraduateTransferApplicationCreateGraduateTransferInputDto:
      <TResponse = unknown, TError = MicrosoftAspNetCoreMvcProblemDetails>(
        data: UserAccountAPIDataTransferObjectsGraduatesTransferCreateGraduateTransferInputDto,
        params: RequestParams = {},
      ) =>
        this.request<TResponse, TError>({
          path: `/application/graduate/transfer/create`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          ...params,
        }),

    /**
     * No description
     *
     * @tags GraduateTransfer
     * @name GraduateTransferCompleteGraduateTransferApplicationGuidRecurlyDetailsDto
     * @request POST:/application/graduate/transfer/{applicationId}/complete
     */
    graduateTransferCompleteGraduateTransferApplicationGuidRecurlyDetailsDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      applicationId: string,
      data: UserAccountAPIDataTransferObjectsRecurlyDetailsDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/application/graduate/transfer/${applicationId}/complete`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  casting = {
    /**
     * No description
     *
     * @tags Casting
     * @name CastingGetGuidBoolean
     * @request GET:/Casting
     * @secure
     */
    castingGetGuidBoolean: <TResponse = unknown, TError = any>(
      query?: {
        /** @format uuid */
        id?: string;
        /** @default true */
        includeAddress?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Casting
     * @name CastingCreateCreateCastingOnlineApplicationDto
     * @request POST:/Casting/create
     */
    castingCreateCreateCastingOnlineApplicationDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsCreateCastingOnlineApplicationDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Casting
     * @name CastingAboutYouGuidCdAboutYouInputDto
     * @request POST:/Casting/AboutYou
     * @secure
     */
    castingAboutYouGuidCdAboutYouInputDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsCDAboutYouInputDto,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting/AboutYou`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Casting
     * @name CastingCompleteGuidRecurlyDetailsDto
     * @request POST:/Casting/Complete
     * @secure
     */
    castingCompleteGuidRecurlyDetailsDto: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsRecurlyDetailsDto,
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting/Complete`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Casting
     * @name CastingPostGeneratePreSignedUrlGuidGeneratePresignedUrlInputDtoNullable1
     * @request POST:/Casting/generatepresignedurl
     * @secure
     */
    castingPostGeneratePreSignedUrlGuidGeneratePresignedUrlInputDtoNullable1: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIDataTransferObjectsGeneratePresignedUrlInputDto,
      query?: {
        /** @format uuid */
        id?: string;
        userType?: UserAccountAPIDataTransferObjectsUserType;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting/generatepresignedurl`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Casting
     * @name CastingLoginCreatedStringString
     * @request POST:/Casting/login-created/{accountId}/{portalId}
     * @secure
     */
    castingLoginCreatedStringString: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      accountId: string,
      portalId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting/login-created/${accountId}/${portalId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Casting
     * @name CastingMarketingPreferencesGuidList1
     * @request POST:/Casting/MarketingPreferences
     * @secure
     */
    castingMarketingPreferencesGuidList1: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: string[],
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Casting/MarketingPreferences`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  discount = {
    /**
     * No description
     *
     * @tags Discount
     * @name DiscountGet
     * @request GET:/Discount
     * @secure
     */
    discountGet: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Discount`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  invites = {
    /**
     * No description
     *
     * @tags Invites
     * @name InvitesGetInt32
     * @request GET:/Invites/yp
     */
    invitesGetInt32: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      query?: {
        /** @format int32 */
        agencyRefNumber?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Invites/yp`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  lookup = {
    /**
     * No description
     *
     * @tags Lookup
     * @name LookupGetLookupsByGroupIdInt32
     * @request GET:/lookup
     */
    lookupGetLookupsByGroupIdInt32: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        groupId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/lookup`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  lookupdescriptions = {
    /**
     * No description
     *
     * @tags Lookup
     * @name LookupGetLookupsDescriptionsByCodeList1
     * @request GET:/lookupdescriptions
     */
    lookupGetLookupsDescriptionsByCodeList1: <
      TResponse = unknown,
      TError = any,
    >(
      query?: {
        code?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/lookupdescriptions`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  lookupgroups = {
    /**
     * No description
     *
     * @tags Lookup
     * @name LookupGetLookupGroups
     * @request GET:/lookupgroups
     */
    lookupGetLookupGroups: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/lookupgroups`,
        method: "GET",
        ...params,
      }),
  };
  maintenance = {
    /**
     * No description
     *
     * @tags Maintenance
     * @name MaintenanceClean
     * @request GET:/Maintenance/clean
     */
    maintenanceClean: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Maintenance/clean`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Maintenance
     * @name MaintenanceCleanUnfinishedCastingApplications
     * @request GET:/Maintenance/cleancasting
     */
    maintenanceCleanUnfinishedCastingApplications: <
      TResponse = unknown,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Maintenance/cleancasting`,
        method: "GET",
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsRegisterDeviceRegisterDeviceDto
     * @request POST:/Notifications/register
     * @secure
     */
    notificationsRegisterDeviceRegisterDeviceDto: <
      TResponse = unknown,
      TError = any,
    >(
      data: UserAccountAPIDataTransferObjectsRegisterDeviceDto,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Notifications/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsDeleteDeviceString
     * @request DELETE:/Notifications/unregister/{token}
     * @secure
     */
    notificationsDeleteDeviceString: <TResponse = unknown, TError = any>(
      token: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Notifications/unregister/${token}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  settings = {
    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetSettings
     * @request GET:/Settings/user
     * @secure
     */
    settingsGetSettings: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/user`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsUpdatePasswordUpdatePasswordRequest
     * @request PUT:/Settings/password
     * @secure
     */
    settingsUpdatePasswordUpdatePasswordRequest: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIApiServicesContractsSettingsUpdatePasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/password`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsUpdateEmailUpdateEmailRequest
     * @request PUT:/Settings/email
     * @secure
     */
    settingsUpdateEmailUpdateEmailRequest: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIApiServicesContractsSettingsUpdateEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/email`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsCancelEmailVerificationEmailVerificationRequest
     * @request POST:/Settings/email/verify/cancel
     * @secure
     */
    settingsCancelEmailVerificationEmailVerificationRequest: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIApiServicesContractsSettingsEmailVerificationRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/email/verify/cancel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsResendEmailVerificationEmailVerificationRequest
     * @request POST:/Settings/email/verify/resend
     * @secure
     */
    settingsResendEmailVerificationEmailVerificationRequest: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIApiServicesContractsSettingsEmailVerificationRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/email/verify/resend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetSecurityQuestions
     * @request GET:/Settings/security-questions
     * @secure
     */
    settingsGetSecurityQuestions: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/security-questions`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetSecurityQuestion
     * @request GET:/Settings/security-questions/current
     * @secure
     */
    settingsGetSecurityQuestion: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/security-questions/current`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsSaveSecurityQuestionSaveSecurityQuestionRequest
     * @request POST:/Settings/security-questions/save
     * @secure
     */
    settingsSaveSecurityQuestionSaveSecurityQuestionRequest: <
      TResponse = unknown,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: UserAccountAPIApiServicesContractsSettingsSaveSecurityQuestionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Settings/security-questions/save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
